import {React,useEffect} from 'react'
import {btnSetColor_CBack,TableDatePicker} from '../function_lib/common_lib';


export function Comp_Edit_Student_Basic(props){
    return(<div className="modal fade bd-example-modal-xl"  id="divEditStudentBasic" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-xl" role="document">
      <div className="modal-content">
      <div className="modal-header bg-primary">
          <h5 className="modal-title text-white" id="exampleModalLabel">Class Fee Master</h5>
          <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" className="text-white">&times;</span>
          </button>
        </div>
        {/* form */}
        <div class="">
    
    {/* <style>
        .ui-menu{
            z-index:9999 !important;
        }
    </style> */}
    <section class="content">
        <div class="container-fluid">
        {props.lsStudentBasic.length>0?
            <form class="form-group" id="frmEditStudentBasic" name="frmEditStudentBasic">
                <input type="hidden" name="res_func" id="res_func" value="stubasic_okSucc" />
                <input type="hidden" name="curl_type" id="curl_type" value="updateStudentBasic" />
                <input type="hidden" name="m_type" id="m_type" value="updateStudentBasic" />
                <input type="hidden" name="stu_id" id="stu_id" value={btoa(props.lsStudentBasic[0]["id"])}/>
                <input type="hidden" name="collection_status" id="collection_status" value="Pending Accession" />
                <input type="hidden" name="e_ref_id" id="e_ref_id" />
                <input type="hidden" name="e_party_id" id="e_party_id"/>

               
                <div class="row">
                    {/* <!-- left column --> */}
                    <div class="col-md-12">
                        <div class="card card-danger">
                   
                            <div class="card-body">
                           {/* start card-body */}
                           <div className="row">
                                <div className="col-lg-3 col-md-3">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Admission Date</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" defaultValue={props.lsStudentBasic[0]["fmt_admit_date"]} id="admit_date" name="admit_date" data-inputmask-alias="datetime" data-inputmask-inputformat="dd/MM/yyyy" data-mask="true" className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                                  </div>
                                  <div className="col-lg-3 col-md-3">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Form No.</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="form_no" name="form_no" defaultValue={props.lsStudentBasic[0]["form_no"]} className="form-control required11" placeholder="" />
                                            </div>
                                        </div>
                                  </div>
                                  <div className="col-lg-3 col-md-3">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Scholar No.</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="scholar_no" name="scholar_no" defaultValue={props.lsStudentBasic[0]["scholar_no"]} className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                                  </div>
                                <div className="col-lg-3 col-md-3">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Admission Type *</label>
                                            <div className="input-group input-group-sm">
                                                <select id="admission_type" name="admission_type" className="form-control required">
                                                  <option value="0">-Select Reg./RTE-</option>
                                                  <option selected={props.lsStudentBasic[0]["admission_type"]==="Regular"} value="Regular">Regular Admission</option>
                                                  <option selected={props.lsStudentBasic[0]["admission_type"]==="RTE"} value="RTE">RTE Admission</option>
                                                  {/* {this.state.stReceiptAmount.map((item,index)=>{
                                                    return <option value={item["id"]+","+item["amount"]}>{item["name"]}</option>
                                                  })} */}
                                                </select>
                                            </div>
                                        </div>
                                  </div>

                                  {/* <div className="col-lg-3 col-md-3">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">S.No</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="sno" name="sno" className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                                  </div> */}

                                  {/* <div className="col-lg-3 col-md-3">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">OPD No.</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="opd_no" name="opd_no" className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                                  </div> */}
                                
                                </div>
                                <div class="row">
                                <div className="col-lg-3 col-md-3">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Student Name</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="student_name" name="student_name" defaultValue={props.lsStudentBasic[0]["student_name"]} className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                                  </div>
                                  <div className="col-lg-3 col-md-3">
                        <div className="form-group">
                                          <label for="exampleInputEmail1">Father's Name</label>
                                          <div className="input-group input-group-sm">
                                              <input type="text" defaultValue={props.lsStudentBasic[0]["father_name"]} id="father_name" name="father_name" className="form-control required11" placeholder="" />
                                          </div>
                                      </div>
                        </div>
                                  <div className="col-lg-2 col-md-2">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Gender</label>
                                            <div className="input-group input-group-sm">
                                            <select id="gender" name="gender" className="form-control required11">
                                                  <option value="">-Select Category-</option>
                                                  {props.genderList.map((item,index)=>{
                                                    return <option selected={props.lsStudentBasic[0]["gender"]===item} value={item}>{item}</option>
                                                  })}
                                                </select>
                                            </div>
                                        </div>
                                  </div> 
                                <div className="col-lg-2 col-md-2">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">DOB</label>
                                            <div className="input-group input-group-sm">
  <input type="text"  id="dob" name="dob" data-inputmask-alias="datetime" data-inputmask-inputformat="dd/MM/yyyy" data-mask="true" className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                                  </div>
                                  <div className="col-lg-2 col-md-2">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Category</label>
                                            <div className="input-group input-group-sm">
                                                <select className="form-control" id="stu_cast_category" name="stu_cast_category">
                                                  <option value={""}>-Select-</option>
                                                  {props.castCategoryList.map((item,index)=>{
                                                    return <option selected={props.lsStudentBasic[0]["stu_cast_category"]===item} value={item}>{item}</option>
                                                  })}
                                                </select>

                                            </div>
                                        </div>
                                  </div>
                                  <div className="col-lg-3 col-md-3">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Cast</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="stu_cast" name="stu_cast" defaultValue={props.lsStudentBasic[0]["stu_cast"]} className="form-control required11" placeholder="" />
                                            </div>
                                        </div>
                                  </div>
                                 
                                  <div className="col-lg-2 col-md-2">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Session Year</label>
                                            <div className="input-group input-group-sm">
                                             <select id="session_year_id" name="session_year_id" className="form-control required form-control-sm">
                                               <option value={"0"}>-Session Year-</option>
                                               {props.lsSessionYear.map((item,index)=>{
                                                return <option selected={props.lsStudentBasic[0]["session_year_id"]===item["id"]} value={item["id"]}>{item["session_name"]}</option>
                                               })}
                                             </select>
                                            </div>
                                        </div>
                                  </div>
                                  <div className="col-lg-2 col-md-2">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Class</label>
                                            <div className="input-group input-group-sm">
                                            <select id="class_id" name="class_id" className="form-control required form-control-sm">
                                               <option value={"0"}>-Classes-</option>
                                               {props.lsClassMaster.map((item,index)=>{
                                                return <option selected={props.lsStudentBasic[0]["class_id"]===item["id"]} value={item["id"]}>{item["class_name"]}</option>
                                               })}
                                             </select>
                                            </div>
                                        </div>
                                  </div>
                                  <div className="col-lg-2 col-md-2">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Section</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="section" name="section" defaultValue={props.lsStudentBasic[0]["section"]} className="form-control required11" placeholder="" />
                                            </div>
                                        </div>
                                  </div>
                                  <div className="col-lg-2 col-md-2">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Shift</label>
                                            <div className="input-group input-group-sm">
                                            <select id="shift" name="shift" className="form-control form-control-sm">
                                                <option value={"0"}>-Select-</option>
                                                <option selected={props.lsStudentBasic[0]["shift"]==="First"} value={"First"}>-First-</option>
                                                <option selected={props.lsStudentBasic[0]["shift"]==="Second"} value={"Second"}>-Second-</option>
                                            </select>
                                                
                                            </div>
                                        </div>
                                  </div>
         
                                </div>  
                        <div className="row">
                        <div className="col-lg-3 col-md-3">
                             <div className="form-group">
                                            <label for="exampleInputEmail1">WhatsApp No.</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="whats_no" name="whats_no" defaultValue={props.lsStudentBasic[0]["whats_no"]} className="form-control required11" placeholder="" />
                                            </div>
                                        </div>
                          </div>
                          <div className="col-lg-3 col-md-3">
                             <div className="form-group">
                                            <label for="exampleInputEmail1">Alt. Contact No.</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="alt_contact_no" name="alt_contact_no" defaultValue={props.lsStudentBasic[0]["alt_contact_no"]} className="form-control required11" placeholder="" />
                                            </div>
                                        </div>
                          </div>
                      </div>
                      <div className="row">    
                          <div className="col-lg-3 col-md-3">
                             <div className="form-group">
                                            <label for="exampleInputEmail1">Place of Birth</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="place_of_birth" name="place_of_birth" defaultValue={props.lsStudentBasic[0]["place_of_birth"]} className="form-control required11" placeholder="" />
                                            </div>
                                        </div>
                          </div>
                          <div className="col-lg-2 col-md-2">
                             <div className="form-group">
                                            <label for="exampleInputEmail1">Total Siblings</label>
                                            <div className="input-group input-group-sm">
                                                <input type="number" id="total_siblings" name="total_siblings" defaultValue={props.lsStudentBasic[0]["total_siblings"]} className="form-control required11" placeholder="" />
                                            </div>
                                        </div>
                          </div>
                          <div className="col-lg-3 col-md-3">
                          <div className="form-group">
                                            <label for="exampleInputEmail1">No of Sibling Study in Same School</label>
                                            <div className="input-group input-group-sm">
                                                <input type="number" id="no_of_sibling" name="no_of_sibling" defaultValue={props.lsStudentBasic[0]["no_of_sibling"]} className="form-control required11" placeholder="" />
                                            </div>
                                        </div>
                          </div>

                        </div>        

                           {/* edn of card-body */}
                            </div>

                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <div class="form-group">

                            <div class="input-group input-group-sm">
                                <button type="button" onClick={()=>props.editStudentBasic("frmEditStudentBasic")} class="btn btn-primary _btnSetColor11">Submit</button>
                            </div>
                        </div>
                    </div>
                    <div class="respSSL"></div>

                </div>
                {/* <!-- /.card-body --> */}
            </form>:''}
        </div>
    </section>
</div>

        {/* end of form */}
      </div>
      </div>
      </div>)
}

export default Comp_Edit_Student_Basic;